import { Checkbox, Collapse, Modal } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router";
import { toast } from "react-toastify";
import Preloader from "../../../core/common/loader/preLoader";
import {
  assignEmpPermission,
  getEmpPermissions,
} from "../../../core/data/redux/rolePermissionsSlice";

const { Panel } = Collapse;

interface Permission {
  id: number;
  name: string;
}

interface PermissionsAccordionProps {
  showModal: any;
  handleModal: () => void;
}

export default function PermissionsAccordionModal(
  props: PermissionsAccordionProps
) {
  const { showModal, handleModal } = props;
  const [permissionData, setPermissionData] = useState<
    Record<string, Permission[]>
  >({});
  const [checkedPermissions, setCheckedPermissions] = useState<number[]>([]);

  const dispatch = useDispatch();
  const roleState = useSelector((state: any) => state.roleState);

  // Fetch permissions on mount
  useEffect(() => {
    if (showModal?.empId)
      dispatch(getEmpPermissions({ empId: showModal?.empId }));
  }, [dispatch, showModal?.empId]);

  // console.log("roleState>>>", roleState);

  // When permissions arrive, update permissionData and checkedPermissions
  useEffect(() => {
    if (
      roleState.loading === "fulfilled" &&
      roleState.action === "get-emp-permission"
    ) {
      const result = roleState?.data?.data || {};
      setPermissionData(result);

      // Pre-check all permissions on load
      const allPermissionIds: number[] = [];
      Object.values(result).forEach((permissions: any) => {
        permissions.forEach((perm: any) => {
          if (perm?.emp_permission) allPermissionIds.push(perm.id);
        });
      });
      setCheckedPermissions(allPermissionIds);
    } else if (
      roleState.loading === "fulfilled" &&
      roleState.action === "assign-emp-permission"
    ) {
      toast.success("Permissions assigned successfully");
      handleModal();
    }
  }, [roleState]);

  // Notify parent when checkedPermissions changes
  useEffect(() => {
    handleSelect(checkedPermissions);
  }, [checkedPermissions, props]);

  const handleSelect = (value: any) => {
    setCheckedPermissions(value);
  };

  // Handle individual checkbox toggle
  const handleCheckboxChange = (id: number, checked: boolean) => {
    setCheckedPermissions((prev) =>
      checked ? [...prev, id] : prev.filter((pid) => pid !== id)
    );
  };

  const handlePermissionSubmit = async () => {
    await dispatch(
      assignEmpPermission({
        permission_id: checkedPermissions,
        empId: showModal.empId,
      })
    );
    // Refresh data after permission assignment
    // setTimeout(() => {
    //   fetchRecords();
    // }, 500);
  };

  return (
    <>
      {roleState.loading === "pending" &&
        roleState.action === "assign-emp-permission" && <Preloader />}

      <Modal
        title={"Assign Permission"}
        open={showModal?.show}
        onCancel={() => {
          handleModal();
        }}
        footer={null}
        destroyOnClose
      >
        <form style={{ marginTop: 25 }}>
          <div className="modal-body mb-3">
            <div className="row">
              <div className="col-md-12">
                {/* <PermissionsAccordion
                  handleSelect={handleSelect}
                  empId={currentItem?.empId}
                /> */}
                <Collapse accordion>
                  {Object.entries(permissionData).map(
                    ([groupName, permissions]) => (
                      <Panel header={groupName} key={groupName}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          {permissions.map((perm) => (
                            <Checkbox
                              key={perm.id}
                              checked={checkedPermissions.includes(perm.id)}
                              onChange={(e) =>
                                handleCheckboxChange(perm.id, e.target.checked)
                              }
                            >
                              {perm.name}
                            </Checkbox>
                          ))}
                        </div>
                      </Panel>
                    )
                  )}
                </Collapse>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <Link
              to="#"
              className="btn btn-light me-2"
              onClick={() => {
                handleModal();
              }}
            >
              Cancel
            </Link>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handlePermissionSubmit();
              }}
            >
              Submit
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
